import i18next from "i18next";

export interface SortByLabelOptions<T> {
  getValue?: (item: T) => unknown;
  locale?: string;
}

function isUnknownValue(value: unknown): boolean {
  return typeof value === "string" && value.toLowerCase() === "unknown";
}

export function sortByLabel<T>(
  items: readonly T[],
  getLabel: (item: T) => string,
  { getValue, locale }: SortByLabelOptions<T> = {},
): T[] {
  const collator = new Intl.Collator(locale ?? i18next.resolvedLanguage ?? i18next.language, {
    numeric: true,
    sensitivity: "base",
  });
  const isUnknown = (item: T) => (getValue ? isUnknownValue(getValue(item)) : false);

  return [...items].sort(
    (left, right) =>
      Number(isUnknown(right)) - Number(isUnknown(left)) || collator.compare(getLabel(left), getLabel(right)),
  );
}
